import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class ReportsService {

  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /* Function to get projects */
  getProjectList(): Observable<any> {
    return this.httpService.post(`project/listFilter`, '')
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }
  getDepartmentWiseTotalEmployeeData():Observable<any>{
    return this.httpService.post(`employee/departmentwise`, '')
    .map((res: Response) => res.json())
    .catch((error: any) => {
      return this.handleError(error);
    });
  }

  /* Function to get employee details */
  getEmployeesDetails(emp): Observable<any> {
    const data = {
      'userDetails': emp
    };
    return this.httpService.post(`employee/dashboard`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  getEmployeesDetailsDeptwise(data): Observable<any> {
    // const data = {
    //   pageSize: 15,
    //   pageNumber: pageNumber,
    //   status: status,
    //   totalEmployees:totalEmployees,
    //   startDate:startDate,
    //   endDate:endDate
    // };
    return this.httpService
      .post(`employee/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to get rm list */
  getrmList(): Observable<any> {
    const data = {
      'role': 'RM'
    };
    return this.httpService.post(`delegation/listemployees`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to get rm project list */
  getRmProjectList(rmId): Observable<any> {
    const data = {
      'rmcode': rmId
    };
    return this.httpService.post(`project/rm/listFilter`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to get locked employee list */
  getLockedList(): Observable<any> {
    return this.httpService.post(`employee/listLockedEmployees`, '')
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to get timesheet report */
  getTimesheetReport(data): Observable<any> {
    return this.httpService.post(`report/timesheetDump`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to get utilization report */
  getUtilizationReport(data): Observable<any> {
    return this.httpService.post(`report/UtilizationReport`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /* Function to handle error data*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/reports/reports.service.ts